import React, { useState } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import Drawer from "../../common/Drawer/AgentListDrawerModal";
import { Heading } from "../../../styles/component/style";
import { makeStyles } from "@material-ui/core";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#ffffff",
    boxShadow: "none",
    margin: "0px !important",
    borderRadius: "8px",
    "& .MuiIconButton-root": {
      padding: 0,
      marginRight: 15,
      backgroundColor: "#fff",
    },
    "& .MuiSvgIcon-root": {
      fill: "#00838c",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Index = ({ fields, setFields, caseDetails, id }) => {
  return (
    <Drawer state={fields} setState={setFields} label="Drawer">
      <Table
        {...{
          fields,
          setFields,
          caseDetails,
          id,
        }}
      />
    </Drawer>
  );
};

export default Index;

const Table = ({ setFields, caseDetails }) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");

  const hasExtraFields =
    caseDetails?.arbitrationAgreementFields &&
    Object.keys(caseDetails.arbitrationAgreementFields).length > 0;

  const extraFieldsArray = hasExtraFields
    ? Object.entries(caseDetails.arbitrationAgreementFields).map(
        ([key, value]) => ({
          key,
          label: _.startCase(key),
          value: value != null ? String(value) : "",
        }),
      )
    : [];

  const filteredFields = extraFieldsArray.filter((field) => {
    if (!searchTerm.trim()) return true;

    const term = searchTerm.toLowerCase().trim();
    return (
      field.label.toLowerCase().includes(term) ||
      field.value.toLowerCase().includes(term)
    );
  });

  return (
    <DrawerContent>
      <Header>
        <HeaderContent>
          <Heading
            style={{
              marginBottom: "unset",
              fontSize: "20px",
              color: COLORS.COLOR_DARK,
            }}
          >
            Case Details
          </Heading>
        </HeaderContent>
        <CloseButton
          onClick={() => {
            setFields(false);
          }}
          aria-label="Close drawer"
        >
          <img
            src={require("../../../assets/images/closeModal.svg")}
            alt="close"
          />
        </CloseButton>
      </Header>

      <ContentWrapper>
        <TableContainer className={classes.root}>
          {hasExtraFields ? (
            <>
              <SearchContainer>
                <SearchIcon
                  src={require("../../../assets/images/searchBar.svg")}
                  alt="search_icon"
                />
                <SearchInput
                  type="text"
                  placeholder="Search by field name or value..."
                  value={searchTerm}
                  style={{ fontFamily: "openSans-SemiBold, sans-serif" }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <ClearButton onClick={() => setSearchTerm("")}>×</ClearButton>
                )}
              </SearchContainer>

              {filteredFields.length > 0 ? (
                <FieldsScrollContainer>
                  {filteredFields.map((field, index) => (
                    <FieldRow key={field.key} index={index}>
                      <FieldLabel>{field.label}</FieldLabel>
                      <FieldValue>{field.value || "—"}</FieldValue>
                    </FieldRow>
                  ))}
                </FieldsScrollContainer>
              ) : (
                <EmptyState>
                  <EmptyText>
                    No matching fields found for "<strong>{searchTerm}</strong>"
                  </EmptyText>
                  <ClearSearchText onClick={() => setSearchTerm("")}>
                    Clear search
                  </ClearSearchText>
                </EmptyState>
              )}
            </>
          ) : (
            <EmptyState>
              <EmptyText>No arbitration agreements fields available</EmptyText>
            </EmptyState>
          )}
        </TableContainer>
      </ContentWrapper>
    </DrawerContent>
  );
};

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fafafa;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 32px;
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f5f5f5;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 24px 32px;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const SearchContainer = styled.div`
  position: relative;
  margin: 16px 20px 20px;
`;

const SearchIcon = styled.img`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 1.1rem;
  pointer-events: none;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 44px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 15px;
  color: #1f2937;
  background: #f9fafb;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 131, 140, 0.12);
  }
`;

const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: #e5e7eb;
  border: none;
  color: #6b7280;
  font-size: 1.2rem;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #d1d5db;
  }
`;

const FieldsScrollContainer = styled.div`
  overflow-y: auto;
  padding: 8px 12px;
  flex: 1;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;

    &:hover {
      background: #a8a8a8;
    }
  }
`;

const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  margin-bottom: 10px;
  background: ${(props) => (props.index % 2 === 0 ? "#fafafa" : "#ffffff")};
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  transition: all 0.2s ease;

  &:hover {
    border-color: #00838c;
    box-shadow: 0 3px 10px rgba(0, 131, 140, 0.08);
    transform: translateX(3px);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const FieldLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.INPUT_LABEL};
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

const FieldValue = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
  word-break: break-word;
  line-height: 1.45;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 60px 32px;
  text-align: center;
`;

const EmptyText = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 12px;
`;

const ClearSearchText = styled.button`
  background: none;
  border: none;
  color: #00838c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  padding: 6px 12px;
  border-radius: 6px;

  &:hover {
    background: rgba(0, 131, 140, 0.08);
  }
`;

export const AccordionHeading = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
`;

export const AccordionContainer = styled.div`
  padding: 0 20px;
`;

export const ImageWrapper = styled.div`
  cursor: pointer;
`;

export const HyperLink = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "0px")};
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledTitle = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  width: 200px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65%;
  margin: 0 auto;
  @media (min-width) {
    justify-content: space-between;
  }
`;

export const CheckedIconContainer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HyperLinkSpan = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  margin-left: 25px;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const HeadingContainer = styled.div`
  position: relative;
  text-align: center;
`;

export const TableHeading = styled.span`
  margin-bottom: 31px;
  font-family: ${theme.fonts.primaryFontExtraBold};
  font-size: 18px;
  flex: 1;
  color: ${COLORS.COLOR_DARK};
  text-transform: capitalize;
`;
